import { render, staticRenderFns } from "./AllegroDesign.vue?vue&type=template&id=7d1f516f&scoped=true&lang=html&"
import script from "./AllegroDesign.vue?vue&type=script&lang=js&"
export * from "./AllegroDesign.vue?vue&type=script&lang=js&"
import style0 from "./AllegroDesign.vue?vue&type=style&index=0&id=7d1f516f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1f516f",
  null
  
)

export default component.exports